module.exports = __webpack_public_path__ + "media/svg-new/information-381b584c.svg";